<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const header = item.querySelector('.accordion-header');
        const icon = header.querySelector('.icon');

        header.addEventListener('click', function() {
            item.classList.toggle('active');

            const content = item.querySelector('.accordion-content');

            if (item.classList.contains('active')) {
                content.style.display = 'block';
               
            } else {
                content.style.display = 'none';
               
            }
        });
    });
});

